module.exports = __webpack_public_path__ + "static/media/single-column.e7d93e18.svg";